import { CFDIUse } from "@app/interfaces/cfdi";

export const CFDI4_USES: CFDIUse[] = [
   { value: 'G03', viewValue: 'Gastos en general' },
   { value: 'S01', viewValue: 'Sin efectos fiscales' },
 ];
